// Module
var code = "<button data-ng-if=\"!qrVisible\" data-ng-click=\"generateScan(); $event.stopPropagation()\" class=\"scannerBtn gcl-subtitle-2\">Generate Scan</button>\n";
// Exports
module.exports = code;